<p-dialog [header]="formHeader" [style]="{width: '70vw', height: '80vw'}" [closable]="true" (onHide)="closeModal()"
    [(visible)]="displayModal" [modal]="true" [styleClass]="'dynamic-form-modal'" [focusOnShow]="false">
    <ng-template pTemplate="header">
        <div class="header-content">
            <p-selectButton [options]="stateOptions" [unselectable]="true" [(ngModel)]="selectedOption" optionLabel="label"
                optionValue="value" />

            <button pButton pRipple style="margin-left: auto; margin-right: 10px" class="p-button-text p-button-rounded p-pt-0"
                icon="pi pi-pencil" *ngIf="mode === 'view'&& permissionType >= WBPermissionType.ReadWrite" (click)="switchToEdit()" class="edit-button"
                aria-label="Edit"></button>
            <p-menu #menu [model]="items" [popup]="true" styleClass="fit-content" appendTo="body" />
            <!-- <p-button (onClick)="menu.toggle($event)" icon="pi pi-briefcase"/> -->
        </div>
    </ng-template>
    <div class="card" style="height:auto !important;">
        <ng-container *ngIf="selectedOption == 'view-mode'">
            <div *ngIf="mode !== 'view'">
                <form [formGroup]="form">
                    <div class="p-grid">
                        <ng-container *ngFor="let column of columnDefinitions">
                            <div class="p-col-12 p-md-6">
                                <label [for]="column.name">{{ column.name }}
                                    <i *ngIf="['FileUpload'].includes(column.formControlName)" class="pi pi-exclamation-circle p-ml-1" [escape]="false" [pTooltip]="multiLineTooltipFile" tooltipPosition="top"></i>
                                    <i *ngIf="['Picture'].includes(column.formControlName)" class="pi pi-exclamation-circle p-ml-1" [escape]="false" [pTooltip]="multiLineTooltipPicture" tooltipPosition="top"></i>
                                </label>
    
                                <ng-container [ngSwitch]="column.formControlName">
                                    <input *ngSwitchCase="'InputBox'" pInputText [formControlName]="column.id"
                                        placeholder="Enter Text Input Only" />
                                    <p-autoComplete *ngSwitchCase="'DropDownList'" [formControlName]="column.id"
                                        [suggestions]="column?.pickListValues" [forceSelection]="true"
                                        (completeMethod)="onDropdownSearch(column, $event.query)" [field]="'value'"
                                        [dropdown]="true" [placeholder]="'Search ' + column.name" [appendTo]="'body'"
                                        [disabled]="column.isLoading" [showClear]="true">
                                        <ng-template pTemplate="item" let-item>
                                            <span>{{ item }}</span>
                                        </ng-template>
                                    </p-autoComplete>
                                    <p-inputNumber *ngSwitchCase="'Number'" [formControlName]="column.id"
                                        placeholder="Enter Number Input Only"></p-inputNumber>
                                    <p-inputNumber *ngSwitchCase="'Decimal'" [formControlName]="column.id" mode="decimal"
                                        placeholder="Enter Decimal Input Only" [minFractionDigits]="1"
                                        [maxFractionDigits]="column?. maxDecimalPlaces ||10"></p-inputNumber>
                                    <p-inputNumber *ngSwitchCase="'Percentage'" [formControlName]="column.id" mode="decimal"
                                        placeholder="Enter Percentage Value" [minFractionDigits]="1"
                                        [maxFractionDigits]="10"></p-inputNumber>
                                    <p-calendar *ngSwitchCase="'DatePicker'" [formControlName]="column.id" [showIcon]="true"
                                        [readonlyInput]="true" [showButtonBar]="true"
                                        [placeholder]="'Please Select ' + column?.name" [appendTo]="'body'"
                                        [responsive]="true"></p-calendar>
                                    <p-calendar *ngSwitchCase="'DateTimePicker'" [formControlName]="column.id"
                                        [showIcon]="true" [readonlyInput]="true" [showButtonBar]="true"
                                        [placeholder]="'Please Select ' + column?.name" [showTime]="true"
                                        [hourFormat]="'12'" class="responsive-calendar" [appendTo]="'body'"
                                        [responsive]="true">
                                    </p-calendar>
                                    <!-- Multiple Dropdown -->
                                    <ng-container *ngSwitchCase="'MultipleDropDownList'">
                                        <p-multiSelect [options]="column?.pickListValues" [formControlName]="column.id" placeholder="Search..."
                                            (onFocus)="onDropdownSearch(column, $event.query)" appendTo="body"
                                            (onFilter)="onDropdownSearch(column, $event.query)"
                                            [placeholder]="'Please Select ' + column?.name" 
                                            [multiple]="true"
                                            [filter]="true">
                                            <ng-template pTemplate="item" let-item>
                                                <span>{{ item | shorten:60 }}</span>
                                            </ng-template>
                                        </p-multiSelect>
                                    </ng-container>
                                    <!-- CheckBox -->
                                    <ng-container *ngSwitchCase="'CheckBox'">
                                        <ng-container *ngFor="let option of column.pickListValues; let i = index">
                                        <p-checkbox 
                                            class="p-mr-2"
                                            [formControl]="form.get(column.id).controls[i]"
                                            [binary]="true" 
                                            [label]="option"
                                            [value]="option">
                                        </p-checkbox>
                                        </ng-container>
                                    </ng-container>
      
                                      <!-- Radio Button -->
                                    <ng-container *ngSwitchCase="'RadioButton'">
                                        <ng-container *ngFor="let option of column?.pickListValues">
                                            <p-radioButton class="p-mr-2" [value]="option" [formControlName]="column?.id"
                                            [label]="option"
                                            >
                                            </p-radioButton>
                                        </ng-container>
                                    </ng-container>
    
                                    <!-- AutoNumber -->
                                    <ng-container *ngSwitchCase="'AutoNumber'">
                                        <input pInputText type="text" [formControlName]="column?.id" [disabled]="true"
                                            [readonly]="true" class="p-disabled"
                                            placeholder="This field value will be auto generated" />
                                    </ng-container>
                                    <!-- Formula -->
                                    <ng-container *ngSwitchCase="'Formula'">
                                        <input pInputText type="text" [formControlName]="column?.id" [disabled]="true"
                                            [readonly]="true" class="p-disabled" 
                                            placeholder="This field value will be auto generated" />
                                    </ng-container>
    
                                    <!-- Multi-Line -->
                                    <ng-container *ngSwitchCase="'Multi-Line'">
                                        <textarea pInputTextarea type="text" [formControlName]="column?.id" 
                                        [placeholder]="'Please Enter ' + column?.name" rows="5" style="max-width:100%"></textarea>
                                    </ng-container>
                                <!-- Email -->
                                <ng-container *ngSwitchCase="'Email'">
                                    <input pInputText type="text" [formControlName]="column?.id" [placeholder]="'Please Enter ' + column?.name"  />
                                    <small *ngIf="form.get(column.id).hasError('pattern') && form.get(column.id).touched"
                                        class="p-invalid">
                                        Please enter a valid {{ column.name }}.
                                        </small>
                                </ng-container>
    
                                <!-- Phone -->
                                <ng-container *ngSwitchCase="'Phone'">
                                    <input pInputText type="text" [formControlName]="column?.id" [placeholder]="'Please Enter ' + column?.name"  />
                                    <small *ngIf="form.get(column.id).hasError('pattern') && form.get(column.id).touched"
                                        class="p-invalid">
                                        Please enter a valid {{ column.name }}.
                                        </small>
                                </ng-container>
    
                                <!-- IPAddress -->
                                <ng-container *ngSwitchCase="'IPAddress'">
                                    <input pInputText type="text" [formControlName]="column?.id" [placeholder]="'Please Enter ' + column?.name"  />
                                    <small *ngIf="form.get(column.id).hasError('pattern') && form.get(column.id).touched"
                                        class="p-invalid">
                                        Please enter a valid {{ column.name }}.
                                        </small>
                                </ng-container>
    
                                <!-- URL -->
                                <ng-container *ngSwitchCase="'URL'">
                                    <input pInputText type="text" [formControlName]="column?.id"
                                        placeholder="Enter URL with http/https" />
                                        <small *ngIf="form.get(column.id).hasError('pattern') && form.get(column.id).touched"
                                        class="p-invalid">
                                        Please enter a valid {{ column.name }}.
                                        </small>
        
                                </ng-container>
    
                                <!-- Barcode -->
                                <ng-container *ngSwitchCase="'Barcode'">
                                    <input pInputText type="text" [formControlName]="column?.id" [placeholder]="'Please Enter ' + column?.name" />
                                </ng-container>
    
                                <!-- EncryptedText -->
                                <ng-container *ngSwitchCase="'EncryptedText'">
    
                                 <p-iconField iconPosition="right">
                                        <p-inputIcon *ngIf="column?.show" styleClass="pi pi-eye"
                                            (click)="column['show']=!column['show']" />
                                        <p-inputIcon *ngIf="!column?.show" styleClass="pi pi-eye-slash"
                                            (click)="column['show']=!column['show']" />
                                        <input pInputText [formControlName]="column?.id" [type]="'text'"
                                            [style]="!column['show'] ? '-webkit-text-security: disc;':''" [placeholder]="'Please Enter ' + column?.name" 
                                            (input)="clearEncryptedText(column)"
                                            />
                                    </p-iconField>
                                </ng-container>
    
                                <!-- Time -->
                                <ng-container *ngSwitchCase="'Time'">
                                    <input pInputText type="time" [formControlName]="column?.id"  [placeholder]="'Please Select ' + column?.name" />
    
                                </ng-container>
                                <!-- Currency -->
                                <ng-container *ngSwitchCase="'Currency'">
                                    <p-inputNumber [formControlName]="column?.id" mode="decimal" 
                                        [placeholder]="currencySymbol"
                                        [placeholder]="'Please Enter Currency'" 
                                        [minFractionDigits]="0"
                                        [prefix]="column?.currencySymbol ? column?.currencySymbol.trim()+ ' ' : currencySymbol + ' '" 
                                        [maxFractionDigits]="6"
                                        [step]="1">
                                    </p-inputNumber>
                                    <small *ngIf="form.get(column.id).hasError('pattern') && form.get(column.id).touched"
                                        class="p-invalid">
                                        Please enter a valid {{ column.name }}.
                                        </small>
                                </ng-container>
    
                                <!-- User Lookup -->
                                <ng-container *ngSwitchCase="'UserLookup'">
                                    <p-dropdown [options]="usersList" [placeholder]="'Select ' + column.name"
                                        [filter]="true" [formControlName]="column.id" optionLabel="name" optionValue="id"
                                        appendTo="body" [showClear]="true"
                                        [placeholder]="'Please Select ' + column?.name" 
                                        >
                                    </p-dropdown>
                                </ng-container>
                                <!-- Ratings -->
                                <ng-container *ngSwitchCase="'Rating'">
                                    <div class="p-d-flex">
                                        <p-rating [formControlName]="column?.id" [cancel]="false">
                                        </p-rating>
                                        <!-- <span class="p-ml-2 pointer">Reset</span> -->
                                        <span *ngIf="form.get(column?.id)?.value" 
                                            class="p-ml-2 btnBars" 
                                            pTooltip="Click here to clear rating"  
                                            tooltipPosition="top" 
                                            (click)="clearRating(column?.id, $event)">
                                      <i class="pi pi-times"></i>
                                  </span>
                                    </div>
                                </ng-container>
                    <!-- Toggle Button -->
                    <ng-container *ngSwitchCase="'ToggleButton'">
                        <p-inputSwitch [formControlName]="column?.id" />
                        <!-- <p-toggleButton onLabel="{{ column?.name }}" offLabel="{{ column?.name }}"
                            [onIcon]="'pi pi-check'" [offIcon]="'pi pi-times'" iconPos="right" [formControlName]="column?.id">
                        </p-toggleButton> -->
                    </ng-container>
                    <!-- RichText -->
                    <ng-container *ngSwitchCase="'RichText'">
                        <p-editor #editor [style]="{'height: auto, min-height':'100px'}" [formControlName]="column?.id" rows="5">
                            <p-header>
                                <span class="ql-formats">
                                    <select class="ql-size">
                                        <option value="small">small</option>
                                        <option selected></option>
                                        <option value="large">large</option>
                                        <option value="huge">huge</option>
                                    </select>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-bold" aria-label="Bold"></button>
                                    <button class="ql-italic" aria-label="Italic"></button>
                                    <button class="ql-underline" aria-label="Underline"></button>
                                    <button class="ql-strike" aria-label="Strike"></button>
                                </span>
                                <span class="ql-formats">
                                    <select title="Text Color" class="ql-color"></select>
                                    <span class="ql-format-separator"></span>
                                    <select title="Background Color" class="ql-background"></select>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-list" value="ordered"></button>
                                    <button class="ql-list" value="bullet"></button>
                                    <select title="Text Alignment" class="ql-align">
                                        <option selected>Gauche</option>
                                        <option value="center" label="Center"></option>
                                        <option value="right" label="Right"></option>
                                        <option value="justify" label="Justify"></option>
                                    </select>
                                </span>
                                <span class="ql-formats">
                                    <button aria-label="Link" class="ql-link"></button>
                                </span>
                            </p-header>
                        </p-editor>
                    </ng-container>
                    <!-- File Upload -->
                    <ng-container *ngSwitchCase="'FileUpload'">
                        <p-fileUpload customUpload="true" class="fupload" previewWidth="100" chooseLabel="Choose"
                            [showUploadButton]="false" [showCancelButton]="false" multiple="multiple"
                            (onSelect)="onCustomUpload($event, column, fileUpload, 'any')" #fileUpload
                            >
                            
                            <ng-template pTemplate="content">
                                <ng-container *ngFor="let file of form.get(column.id).value; let i = index;">
                                    <div class="p-fileupload-row" *ngIf="file">
                                        <!-- Download Button -->
                                        <button pButton icon="fa fa-download" (click)="downloadFile(file, $event, true)"
                                            class="p-button-link p-px-0 p-py-0" [pTooltip]="'Download: '+file?.fileName" tooltipPosition="top">
                                        </button>
                    
                                        <div [pTooltip]="file?.fileName.substring(0, 30)" class="pointer"(click)="downloadFile(file, $event, false)"> {{ file?.fileName | shorten:30 }} </div>
                                        <!-- Remove Button -->
                                        <div>
                                            <button pButton type="button" icon="pi pi-times" (click)="deleteDocument(file, column, i)">
                                            </button>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-template>
                        </p-fileUpload>
                    </ng-container>                                                
    
                    <!-- Picture -->
                    <ng-container *ngSwitchCase="'Picture'">
                        <p-fileUpload customUpload="true" class="fupload" previewWidth="100" chooseLabel="Choose"
                            [showUploadButton]="false" [showCancelButton]="false" accept="image/*" multiple="multiple"
                            (onSelect)="onCustomUpload($event, column, fileUpload, 'image')" #fileUpload
                            >
                            
                            <ng-template pTemplate="content">
                                <ng-container *ngFor="let file of form.get(column.id).value; let i = index;">
                                    <div class="p-fileupload-row" *ngIf="file">
                                        <!-- Download Button -->
                                        <button pButton icon="fa fa-download" (click)="downloadFile(file, $event, true)"
                                            class="p-button-link p-px-0 p-py-0" [pTooltip]="'Download: '+file?.fileName" tooltipPosition="top">
                                        </button>
                    
                                        <div [pTooltip]="file?.fileName.substring(0, 30)" class="pointer" (click)="downloadFile(file, $event, false)"> {{ file?.fileName | shorten:30 }} </div>
                                        <!-- Remove Button -->
                                        <div>
                                            <button pButton type="button" icon="pi pi-times" (click)="deleteDocument(file, column, i)">
                                            </button>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-template>
                        </p-fileUpload>
                    </ng-container>
                            </ng-container>
                            </div>
                        </ng-container>
                    </div>
                </form>
            </div>
            <div *ngIf="mode === 'view'">
                <form [formGroup]="form">
                    <div class="p-grid">
                        <ng-container *ngFor="let column of columnDefinitions">
                            <ng-container *ngIf="['RichText', 'Multi-Line'].includes(column.formControlName) else defaultField">
                                <div class="p-col-12 p-d-flex p-p-0">
                                    <div class="p-col-4 p-md-2">
                                        <div><strong>{{ column.name }}</strong></div>
                                    </div>
                                    <div class="p-col-8 p-md-10">                        
                                        <div *ngIf="column.formControlName === 'RichText'">
                                            <div [innerHTML]="rawHTML(form.get(column.id).value)"></div>
                                        </div>
                            
                                        <div *ngIf="column.formControlName === 'Multi-Line'">
                                            <span style="white-space: pre-line;">
                                                {{ form.get(column.id).value }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-template #defaultField>
                            <div class="p-col-4 p-md-2">
                                <div><strong>{{ column.name }}</strong></div>
                            </div>
                            <div  class="p-col-8 p-md-4">
                                <div *ngIf="!excludedFields.includes(column.formControlName)">
                                    {{form.get(column.id).value}}</div>
                            <div *ngIf="column.formControlName == 'DatePicker'">{{form.get(column.id).value |
                                    date:'MM/dd/yyyy'}}</div>
                                <div *ngIf="column.formControlName == 'DateTimePicker'">{{form.get(column.id).value |
                                    date:'MM/dd/yyyy | hh:mm a'}}</div>
                                <div *ngIf="column.formControlName == 'Percentage'">{{form.get(column.id).value}}<span
                                        *ngIf="form.get(column.id).value">%</span></div>
                                <div *ngIf="column.formControlName === 'Phone'">
                                    {{ form.get(column.id).value }}
                                    </div>                                
                                    <div *ngIf="column.formControlName === 'Currency'">
                                    {{ form.get(column.id).value | currencySymbol: null : column?.currencySymbol }}
                                    </div>
                                    <div *ngIf="column.formControlName === 'CheckBox'">
                                        @if(form.get(column.id).value){
                                        {{ getCheckBoxValue(column)}}
                                        }   
                                    </div>
                                                                        
                                    <div *ngIf="column.formControlName === 'EncryptedText'">
                                    {{ form.get(column.id).value || '' }}
                                    </div>
                                    
                                    <div *ngIf="column.formControlName === 'UserLookup'">
                                        <span class="truncate pointer" (click)="openTaggedUserDetails(form.get(column.id).value)">
                                            {{ getSelectedUserName(form.get(column.id).value)}}
                                        </span>
                                    </div>
                                    <div *ngIf="column.formControlName === 'Time'">
                                        {{ form.get(column.id).value | onlyTime }}
                                        </div>
                                    <div *ngIf="column.formControlName === 'Decimal'">
                                        {{ form.get(column.id).value | number: '1.0-' + (column?.maxDecimalPlaces || 2) || '1.0-2' }}
                                    </div>   
                                    <div *ngIf="column.formControlName === 'URL'">
                                    <a [href]="form.get(column.id).value | url" target="_blank">{{ form.get(column.id).value }}</a>
                                    </div>  
                                    <div *ngIf="column.formControlName === 'Barcode'">
                                        <ngx-barcode6 [bc-value]="form.get(column.id).value" [bc-display-value]="true" [bc-height]="35"
                                        [bc-font-size]="13" [bc-width]="1">
                                    </ngx-barcode6>
                                    </div>
                                    <div *ngIf="column.formControlName === 'FileUpload' || column.formControlName === 'Picture'">
                                        <div class="p-d-flex">
                                            <span [pTooltip]="form.get(column.id).value[0]?.fileName" tooltipPosition="top">
                                              {{form.get(column.id).value[0]?.fileName | shorten:25}}
                                            </span>
                                            <span *ngIf="form.get(column.id).value.length" class="p-ml-2 pointer" 
                                            (click)="openFiles(form.get(column.id).value);">
                                              ({{form.get(column.id).value.length}})
                                            </span>
                                        </div>
                                        <!-- <div class="p-d-flex p-flex-column" *ngFor="let item of form.get(column.id).value">
                                            <span>
                                            <i
                                            class="pi pi-download cursor-pointer p-mr-2" (click)="downloadFile(item, $event)" [pTooltip]="'Download: '+item?.fileName" tooltipPosition="top"></i>
                                            <span [pTooltip]="item?.fileName" tooltipPosition="top" class="pointer" (click)="downloadFile(item, $event, false)">  {{ item?.fileName | shorten:30}}</span>
                                            </span>
                                        </div> -->
                                    </div>          
                            </div>
                            </ng-template>
                        </ng-container>
                    </div>
                </form>
            </div>
        </ng-container>
        <!-- <div *ngIf="selectedOption == 'comments'">
            <app-shared-activities-timeline [objectId]="106071"
            objectType="Account" [isOnlyLog]="true" [hideEmailSyncIcon]="false"
            [selectedObject]="selectedAccount" [isLogOnly]="true"
            [channelId]="1" [objectTypeId]="2">
            </app-shared-activities-timeline>
        </div> -->
        <div *ngIf="selectedOption == 'comments'">
            <app-workbook-comment [workbookId]="this.dynamicTableData.id" [rowNumber]="rowNumber" [updateReadStatus]="true">
            </app-workbook-comment>
        </div>
    </div>
    <p-footer>
        <button pButton type="button" label="Close" (click)="closeModal()"></button>
        <button pButton type="button" label="Save" (click)="onSubmit()" *ngIf="mode !== 'view'"
            [disabled]="form.invalid || !isFormChanged"></button>
        <button pButton type="button" label="Save & View" (click)="onSubmit('view')" *ngIf="mode !== 'view'"
            [disabled]="form.invalid || !isFormChanged"></button>
    </p-footer>
</p-dialog>
<ng-container *ngIf="displayUserDetails&&selectedUser">
  <user-details-modal [display]="displayUserDetails" [selectedUserId]="selectedUser"
  (close)="closeTaggedUserDetails()"></user-details-modal>  
</ng-container>

<p-dialog header="File Uploaded" [(visible)]="displayFiles" [modal]="true" [style]="{width: '60vw'}">
    <div class="card">
        <p-table [value]="allFiles">
          <ng-template pTemplate="header">
              <tr>
                  <th>Name</th>
                  <!-- <th>Updated Date</th> -->
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-file>
              <tr>
                  <td class="p-d-flex">
                    <span class="pi pi-download p-mr-2 pointer" (click)="downloadFile(file,$event, true)" 
                    [pTooltip]="'Download: '+file?.fileName" tooltipPosition="top"></span> 
                    <a target="_blank" rel="noopener noreferrer" (click)="downloadFile(file, $event,false)"
                    class="truncate pointer" [pTooltip]="'View: '+ file?.fileName" tooltipPosition="top">
                    {{file.fileName}}</a>
                  </td>
                  <!-- <td></td> -->
              </tr>
          </ng-template>
        </p-table>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayFiles=false" label="Cancel" class="p-button-secondary"></button>
    </p-footer>
</p-dialog>

<!-- export -->
<app-export-confirm [display]="displayExportConfirm" (onClose)="onCloseExportHide($event)">
</app-export-confirm>